export default {
  "content": "<g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 19v5h5L19.743 9.255l-5-4.999L0 19.001zM23.61 5.39c.52-.52.52-1.36 0-1.88L20.49.39c-.52-.52-1.36-.52-1.88 0l-2.439 2.44 5 4.999 2.44-2.44z\" fill=\"#000\" fill-rule=\"nonzero\"/><path d=\"M0 0h24v24H0z\"/></g>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};